export const Resources = {
    SubscribeAriaLabel: 'Harpidetu hemen Ministerioaren azken berriak eta/edo prentsa oharrak jasotzeko',
    BellGreetingLogged: 'Kaixo ',
    BellGreeting: 'Kaixo!',
    BellText01: 'Agian zure interesekoak izango dira harpidetza hauek:',
    BellText02: 'Harpidetza helbide elektroniko honekin lotuko da:',
    BellText03: 'Helbidea aldatu nahi baduzu, erabiltzailearen datuen edizioan egin ahalko duzu.',

    SubscribeTitle: 'Harpidetu',
    SubscribeTitleUperCase: 'HARPIDETU',
    SubscribeBtnTitle: 'Harpidetu zaitez Ministerioko Newsletterretara',
    LoginSignUpUperCase: 'IZENA EMAN',
    SubscriptionsManagerUperCase: 'HARPIDETZEN KUDEAKETA',

    Cancel: 'Ezeztatu',
    Ok: 'Ok',

    SendActivationMailButton: 'Bidali aktibatzeko posta elektronikoa',
    SendActivationMailOK: 'Posta elektronikoa behar bezala bidali da adierazitako helbidera.',
    SendActivationMailError: 'Errorea gertatu da posta bidaltzean. Saiatu berriro beranduago.',
    
    LoginAuthentication: 'Identifika zaitez',
    LoginRecoverPass: 'Berreskuratu pasahitza',
    LoginSignUpText: 'Oraindik ere konturik ez baduzu',
    LoginButton: 'Identifika nazazu botoia',
    
    ToolTipCheckBell: 'Harpidetza deuseztatzeko "Harpidetzen kudeaketa" atalera jo behar duzu',
    EnterEmail: 'Email-a idatzi',
    EnterPass: 'Pasahitza idatzi',

    RecoveryAccountModal: 'Pasahitza berreskuratzeko mezua bidaliko da zehaztutako helbide elektronikora',
    RecoveryAccountModalMailSended: 'Helbide elektronikoa erregistratuta badago, mezu bat jasoko duzu sarrerako ontzian',
   
    //--------- Mensajes de Error -------------
    // SecurityPasswordChange: ServiceMessage1
    // InvalidCredentials: ServiceMessage3    
    // MailInUse: ServiceMessage4
    // DocInUso: ServiceMessage5
    // SendActivationEmailError: ServiceMessage6
    // SendRecoveryEmailError: ServiceMessage7
    // InvalidToken: ServiceMessage8
    // InternalServiceError: ServiceMessage9
    // GenerateJWTNoUser: ServiceMessage10
    // NoGroupId: ServiceMessage11
    // NoAuthenticated: ServiceMessage12
    // NoActiveUser: ServiceMessage13
    // NewActivationTokenError: ServiceMessage14
    // UserNoExist: ServiceMessage16

    ServiceMessage1: 'Harpidetzetara sartzeko segurtasun sistema hobetu egin dugu eta, horren ondorioz, pasahitza aldatu behar duzu. “Berreskuratu pasahitza” ataletik aldatu ahalko duzu.',
    ServiceMessage2: '',
    ServiceMessage3: 'Adierazitako helbide elektronikoa ez dago kontu bati lotuta edo pasahitza okerra da.',
    ServiceMessage4: 'Emandako helbide elektronikoa dagoeneko erabiltzen ari da.',
    ServiceMessage5: 'Nortasun agiria dagoeneko erabiltzen ari da.',
    ServiceMessage6: 'Erabiltzailea behar bezala sortu da. Errorea gertatu da erabiltzailea aktibatzeko posta elektronikoa bidaltzean.',
    ServiceMessage7: 'Errorea gertatu da erabiltzailea berreskuratzeko posta elektronikoa bidaltzean.',
    ServiceMessage8: 'Identifikatzailea okerra da edo iraungi da. Erabiltzaile berria bazara, erregistro berri bat egin beharko duzu.',
    ServiceMessage9: 'Zerbitzuaren barne errorea.',
    ServiceMessage10: 'Ezin da erabiltzailea berreskuratu.',
    ServiceMessage11: 'Errore bat gertatu da erabiltzailearen argitalpenak eskuratzean. Mesedez, arazoa konpontzen ez bada, jarri harremanetan zerbitzu teknikoarekin.',
    ServiceMessage12: 'Ez dago erabiltzailerik saio aktiboa duenik.',
    ServiceMessage13: 'Erabiltzaileak oraindik ez du kontua aktibatu.',
    ServiceMessage14: 'Errorea gertatu da aktibazio kode berri bat sortzean.',
    ServiceMessage15: '',
    ServiceMessage16: 'Adierazitako helbide elektronikoa ez dago kontu bati lotuta.',
    ServiceMessage17: 'Uneko pasahitza ez da zuzena.',
    ServiceMessage19: "Pasahitz berria ezin da uneko pasahitzaren berdina izan.",
    ServiceMessage21: "Captcha eremua bete behar da.",

    ServiceMessage503: 'Harpidetza zerbitzua ez dago erabilgarri, saiatu berriro beranduago. Barkatu eragozpenak.',
    
    ErrorCode0: 'Ok',
    ErrorCode1: 'Helbide elektronikoa ezin da hutsik utzi',
    ErrorCode2: 'Helbide elektronikoa ez da zuzena',
    ErrorCode3: 'Pasahitza ezin da hutsik utzi',
    ErrorCode4: 'Gutxienez harpidetza bat aukeratu behar da',
    ErrorCode5: 'Captcha eremua bete behar da',
    ErrorCode6: 'Hautatutako pasahitza ez da behar bezain segurua. Gutxienez ere 8 karaktere, letra larriak, letra xeheak, zenbakiak eta ikurrak izan behar ditu. Hauek dira onartutako ikurrak: _!@#$%^&*.-',
}